import script from "./BrainSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./BrainSearch.vue?vue&type=script&setup=true&lang=js"

import "./BrainSearch.vue?vue&type=style&index=0&id=482c6c27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-482c6c27"]])

export default __exports__